import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { AwsSqsService } from '../../../services/aws-sqs.service';
import * as Constants from '../../../models/Constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CustBusService } from 'src/app/services/customer-search-bussiness-logic.service';
import { DashboardFilterComponent } from '../dashboard-filter/dashboard-filter.component';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { AppointmentsCardService } from 'src/app/services/appointments-card.service';



@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {


  // Below code to be used and to be removed from multiple places once all the dropdowns are made common.
  // @ViewChild(MatSelect) select!: MatSelect;
  // @HostListener('window:scroll', [])
  // onScroll(): void {
  //   if (this.select.panelOpen) {
  //     this.select.close();
  //   }
  // }
  public iconConfig = {
    iconName: 'bank',
    iconType: 'light'
  }
  public iconConfig1 = {
    iconName: 'resume',
    iconType: 'light'
  }

  public iconConfig2 = {
    iconName: 'arrow-right',
    iconType: 'light',
    iconPlacement: 'right',
  };

  userDetails?: any;
  inboundMsg: string = Constants.INBOUND_CALL_ACCESS_ERRORMSG;
  selectedMenu: string = '';
  errorMsg: string = Constants.LEFT_NAV_CARD_FAILURE_MSG;
  loaderType = Constants.LOADER_TYPE.CARD;
  tempMenuId: string = "";

  constructor(
    public genesysCloudService: GenesysCloudService,
    private awsSqsService: AwsSqsService,
    private http: HttpClient,
    public rootScope: RootScopeService,
    public customerService: CustBusService,
    public dialog: MatDialog,
    private apiService: ApiService,
    public appointmentsCardService: AppointmentsCardService) { }

  ngOnInit(): void {
    this.selectedMenu = this.rootScope.selectedMenu;
    /* istanbul ignore next */
    setTimeout(() => {
      if (this.customerService.clients?.length === 0 || this.customerService.clients[0]?.clientId === 0) {
        this.customerService.getClientDetails();
      }
    }, 800);
    let isConnected = localStorage.getItem('TBAGUIStatusConnected');
    // const genesysToken='access_token';
    // const tokenType='token_type=bearer';   

    // if(this.router.url.includes(genesysToken) && this.router.url.includes(tokenType)){
    //   this.connectToGenesys();
    // }
    this.rootScope.timerStarted = true;
  }
  connectToGenesys() {

    this.genesysCloudService.sendMessage(true);
    sessionStorage.setItem('connectToGenesys', 'true');
  }


  /* Below goToAlightCloud() method open the Alight Cloud application*/
  // goToTBASystem() {
  //   let isConnected = localStorage.getItem('TBAGUIStatusConnected');
  //   if (!isConnected) {
  //     alert("Please do TBA Registration from Care Portal, for Access TBA System.");
  //   }
  //   else {
  //     this.tbaSystem()
  //       .subscribe({
  //         next: (data: any) => {
  //           if (data?.httpStatusCode == 200) {
  //             console.log('goToTBASystem', data);
  //           }
  //         },
  //         error: (error) => {
  //           console.log('Error in goToTBASystem', error);
  //           this.rootScope.enableAlerts(Constants.ERROR, Constants.API_FAILURE_MSG);
  //         },
  //       });
  //   }
  // }

  /* Below tbaSystem() method access the TBA System Screen
  from the Care Portal*/
  // tbaSystem(): Observable<any> {
  //   console.log('Method tbaSystem called');
  //   const tbaPort = localStorage.getItem('tba_port');
  //   const sessionId = localStorage.getItem('tba_sessionId');
  //   let url = 'https://localhost:' + tbaPort + '/tbagui'
  //   console.log("tbaSystem URL" + url);
  //   let payload = {
  //     "focus": "",
  //     "sessionId": sessionId,
  //     "lifecycle": "A",
  //     "tranId": "",
  //     "prsnIntnId": "",
  //     "action": "SET_SYSTEM_MODE_ON",
  //     "lockedCd": "",
  //     "fastpath": "",
  //     "funcId": "",
  //     "aci": "",
  //     "tac": "",
  //     "vrs": "",
  //     "refId": "",
  //     "docId": "",
  //     "reasonCd": "",
  //     "origId": "",
  //     "actId": "",
  //     "actIdType": ""
  //   };
  //   console.log('tbaCustomerAccount url', url);
  //   let headers = new HttpHeaders()
  //     .append('Content-Type', 'application/json')
  //   return this.http.post(url, payload, {
  //     headers: headers,
  //     responseType: 'text',
  //   });
  // }

  userId: any = '';
  getUserId() {
    
    this.genesysCloudService.getUserMe().subscribe((userDetails) => {
      this.userId = userDetails?.id;
      localStorage.setItem('userId', this.userId);
      this.genesysCloudService.genesysCloudNotificationSetup();
    });
  }

  goToCaseManagement() {
    window.open('https://hrxassist-api-dev.cloudapp.ngahr.com/', "_blank", "toolbar=yes,scrollbars=yes");
  }

  goToCaseManagement2() {
    window.open('https://hrxassist-api-dev.cloudapp.ngahr.com/', "toolbar=yes,scrollbars=yes");
  }

  // chatConnect() {
  //   var chatWindowIsMinimized = false;

  //   if(!window._genesys){
  //     window._genesys={}
  //   }

  //   window._genesys.widgets.onReady = function (QuickBus) {

  //     let localWidgetPlugin = CXBus.registerPlugin('CustomChatPlugin');

  //     localWidgetPlugin.subscribe("WebChat.messageAdded", function (e) {
  //       if (chatWindowIsMinimized) {
  //         console.log('Message added while Chat Window is minimized', e.data);
  //       } else {
  //         console.log('Message added while Chat Window is opened', e.data);
  //       }
  //     });

  //     localWidgetPlugin.subscribe("WebChat.minimized", function () {
  //       console.log('Chat Window minimized');
  //       chatWindowIsMinimized = true;
  //     });

  //     localWidgetPlugin.subscribe("WebChat.unminimized", function () {
  //       console.log('Chat Window unminimized');
  //       chatWindowIsMinimized = false;
  //     });

  //     localWidgetPlugin.subscribe("WebChatService.messageReceived", function (e) {
  //       if (chatWindowIsMinimized) {
  //         console.log('Message received while Chat Window is minimized', e.data);
  //       } else {
  //         console.log('Message received while Chat Window is opened', e.data);
  //       }
  //     });

  //   };
  // }

  testAWSFramework() {
    // console.log("Method testAWSFramework called")
    this.awsSqsService.sendLogsToSQSQueue();
  }

  buttonClick(event) {
    // console.log("Method buttonClick called , type = ", event?.type)
    if (event?.type == Constants.ALIS_REGISTER_POPUP) {
      this.genesysCloudService.handleContinueButtonALISRegisterPopup();
    }
  }

  /**Below method took the value of selected menu and selected sub-menu when user click
   *  on the any of the link of My Dashboard Left Nav Bar and set it to the rootScope service 
   * variables which show the active link with blue color in the Left Nav Bar Link.*/
  activateLeftMenu(menu, subMenu ) {
    if(subMenu?.subMenuList?.length > 0){
      return;
    }
    this.rootScope.isErrorToHide = true;
    this.rootScope.isWarningToHide = true;
    this.rootScope.selectedSubMenu = subMenu?.id;
    this.rootScope.selectedMenu = menu?.id;
    let selectedLink = this.rootScope.dashboardNavBarData.find(xx => xx.id == menu?.id)?.subMenuList.find(x => x.id == subMenu?.id);
    if (selectedLink && selectedLink?.actionCode == "LINK_ACTION") {
      this.rootScope.selectedLeftNavBarLink(selectedLink, false);
    } else {
      this.rootScope.logEvent(Constants.ERROR, Constants.RSN_CODE_LINK_CONFIG_MISSING + ': Link Configuration is missing')
      this.rootScope.enableAlerts(Constants.ERROR, Constants.RSN_CODE_LINK_CONFIG_MISSING + ": " + Constants.AlertMsg.error500);

    }

  }

  /**
   * Story No - CCR1-7070
   * @param selectedLink 
   * @param menu 
   * @param event 
   */
   /* istanbul ignore next */
  activateLink(selectedLink,menu ,event){
    event.stopPropagation();
    if (selectedLink && selectedLink?.actionCode == "LINK_ACTION") {
      this.rootScope.selectedLeftNavBarLink(selectedLink, false);
    } else {
      this.rootScope.logEvent(Constants.ERROR, Constants.RSN_CODE_LINK_CONFIG_MISSING + ': Link Configuration is missing')
      this.rootScope.enableAlerts(Constants.ERROR, Constants.RSN_CODE_LINK_CONFIG_MISSING + ": " + Constants.AlertMsg.error500);

    }
  }

  /** Below method set the selectedMenu to Dashboard Business Engine when the dashboard client value change
   * and the respective Left Nav Bar data fetched from Backend Service */
  getExpand(event) {
    this.selectedMenu = this.rootScope.dashboardNavBarData[0]?.id;
  }

  openFilter() {
    this.rootScope.openFilterDialog = true;
  }

  closeFilter() {
    this.rootScope.openFilterDialog = false;
  }

}
